/**
 * Persist completed in-app tours per user (localStorage).
 * Shape: { [tourId]: { completedAt: ISO string, version: number } }
 */

const STORAGE_PREFIX = "beyundai_tours_v1";

function storageKey(uid) {
  const id = String(uid || "guest").trim() || "guest";
  return `${STORAGE_PREFIX}:${id}`;
}

function readAll(uid) {
  try {
    const raw = localStorage.getItem(storageKey(uid));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(uid, data) {
  try {
    localStorage.setItem(storageKey(uid), JSON.stringify(data || {}));
  } catch {
    // private mode / quota — ignore
  }
}

export function isTourCompleted(uid, tourId, version = 1) {
  const entry = readAll(uid)[tourId];
  if (!entry) return false;
  return Number(entry.version || 1) >= Number(version || 1);
}

export function markTourCompleted(uid, tourId, version = 1) {
  const all = readAll(uid);
  all[tourId] = {
    completedAt: new Date().toISOString(),
    version: Number(version || 1),
  };
  writeAll(uid, all);
}

export function clearTourCompleted(uid, tourId) {
  const all = readAll(uid);
  if (!tourId) {
    writeAll(uid, {});
    return;
  }
  delete all[tourId];
  writeAll(uid, all);
}

export function listCompletedTours(uid) {
  return { ...readAll(uid) };
}
